import { TeamRole } from '@/consts/team'

import { MemberRow } from '../components/MemberTable'
import { MemberStatus } from '../types/types'

export function mapStatus(status?: number): MemberStatus {
  if (status === 1) return 'uninitialized'
  if (status === 2) return 'suspended'
  if (status === 3) return 'inactive'
  if (status === 4) return 'deleted'
  return 'active'
}
export function mapRole(role?: number): string {
  if (role === 1) return 'Owner'
  if (role === 2) return 'Admin'
  if (role === 3) return 'Member'
  return 'Invalid'
}
export function toISOSafe(sec?: number): string {
  return sec ? new Date(sec * 1000).toISOString() : ''
}

export function deriveUsername(user: any): string {
  const nick = user?.nickname?.trim?.()
  if (nick) return nick

  const raw = (user?.name ?? user?.username ?? '').trim()
  if (!raw) return ''

  const at = raw.indexOf('@')
  return at > 0 ? raw.slice(0, at) : raw
}

function asTeamRole(input: unknown): TeamRole {
  const n = Number(input)
  if (n === TeamRole.Owner || n === TeamRole.Admin || n === TeamRole.Normal) {
    return n as TeamRole
  }
  return TeamRole.Invalid
}

export function normalizeMember(m: any): MemberRow {
  const resId = m?.res_id ?? m?.resID
  const username = deriveUsername(m?.user) || String(resId ?? '')

  return {
    id: String(resId),
    name: (m?.user?.name ?? '').trim(),
    username,
    status: mapStatus(m?.user?.status),
    role: asTeamRole(m?.user?.role),
    bindStatus: m?.user?.bindParent,
    balance:
      typeof m?.account?.totalBonus?.moneyCent === 'number' ? m.account.totalBonus.moneyCent : 0,
    lastLogin: toISOSafe(m?.user?.lastLoginAt?.seconds),
  }
}
